<template>
    <button class="cw-button-hollow cw-button-hollow-secondary uk-width-medium" @click.prevent="modalStatusStore.showLeadModal()">
        <span class="uk-flex uk-flex-middle uk-flex-center">
        <BaseIcon v-if="showIcon" height="20" stroke-width="2" width="20">
            <IconTag></IconTag>
        </BaseIcon>
        &nbsp;{{ buttonText }}
        </span>
    </button>
</template>

<script setup>
import {useModalStatusStore} from "../../stores/ModalStatusStore";
import BaseIcon from "../ui/BaseIcon.vue";
import IconTag from "../icons/IconTag.vue";

const modalStatusStore = useModalStatusStore()

const props = defineProps({
    showIcon: Boolean,
    buttonText: String
})
</script>
